<template>
  <div>
    <el-card>
      <el-page-header :content="title" style="margin-bottom: 30px;" @back="goBack" />
      <nav class="input" style="width: 150px">
        <el-button type="primary" size="small" @click="add">{{
          '添加渠道'
        }}</el-button>
      </nav>
    </el-card>
    <el-card style="margin-top: 10px">
      <el-table :data="list" style="width: 100%" border stripe :header-cell-style="rowClass">
        <el-table-column prop="id" label="编号" width="80" />
                <el-table-column prop="name" label="渠道名称(点击短链可以直接复制)">
                    <template slot-scope="ew">
                        <p>
                            {{ ew.row.name }}
                        </p>
                        <a v-if="ew.row.sunCode" :href="ew.row.sunCode" target="“_blank”">(渠道二维码)</a>
                        <p v-if="ew.row.shortUrl" style="cursor: pointer;" @click="copyToClipboard(ew.row.shortUrl)">
                            {{ ew.row.shortUrl }}（小程序）
                        </p>
                        <p v-if="ew.row.pcUrl" style="cursor: pointer;" @click="copyToClipboard(ew.row.pcUrl)">
                            {{ ew.row.pcUrl }} （PC）
                        </p>
                         <p v-if="ew.row.h5" style="cursor: pointer;" @click="copyToClipboard(ew.row.h5)">
                            {{ ew.row.h5 }} （H5）
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="using" label="渠道用途" />
                <el-table-column prop="landingPage" label="渠道落地页">
                    <template slot-scope="ew">

                        <p v-if="ew.row.landingPage">
                            {{ ew.row.landingPageTxt }}
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="couponName" label="绑定优惠券" />
                <el-table-column prop="activityTitle" label="活动">

                </el-table-column>
                
                 <el-table-column prop="remark" label="备注">
                    <template slot-scope="ew">

                       <!-- <Remark :changeData="false"  :row="ew"
                                :val="{ url: '/admin/Activity/channelRemark', pw: 'channel_remark' }"
                                :getlist="getlist" /> -->
                                
                           <div>
                              <Remarks v-show="$store.state.btn_if.indexOf('channel_remark') != -1" :typecpn="2" :idKey="'id'" style="margin-top: 20px" :row="ew.row" 
                            url="/admin/Activity/channelRemark" @getlist="getlist"
                            :val="{ url: '/admin/Activity/channelRemark', pw: 'channel_remark'}"></Remarks>
                        <template v-if="$store.state.btn_if.indexOf('channel_remark') == -1">
                            {{ ew.row.remark }}</template>
                           </div>
                    </template>
                </el-table-column>
        <!-- <el-table-column prop="id" label="ID" />

        <el-table-column prop="name" label="渠道名称">
          <template slot-scope="{row}">
            <p>{{ row.name }}</p>
            <p v-if="row.sunCode">
              <a :href="baseurl + yu + row.sunCode" target="“_blank”">(小程序渠道二维码)</a>
            </p>
            <a v-if="row.h5" :href="row.h5" target="“_blank”">(H5渠道链接)</a>
          </template>
        </el-table-column> -->
        <el-table-column prop="createTime" label="创建时间" />
        <el-table-column prop="applyNumber" label="报名人数">
          <template slot-scope="{row}">
            <el-button type="primary" size="mini" @click="handleClick(row)">
              {{ row.applyNumber }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="channelApplyNum" label="去重人数"/>
        <el-table-column prop="viewNumber" label="浏览人数" />
        <el-table-column prop="remark" label="备注">
          <template slot-scope="{row}">
            <Remark :row="row" url="/admin/Activity/channelRemark"></Remark>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{row}">
            <el-button v-show="$store.state.btn_if.indexOf('activity_list_edit') != -1" type="text" icon="el-icon-edit"
              size="mini" class="skyblue" @click="edit(row)">编辑</el-button>
            <el-button v-show="$store.state.btn_if.indexOf('cooperation_white_del') != -1" type="text"
              icon="el-icon-delete" size="mini" class="red" @click="open(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="this.search.page" background :page-sizes="[3, 5, 10, 15]"
        :page-size="this.search.pageSize" layout="total, prev, pager, next" :total="total"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </el-card>
    <!-- <Drawers ref="drawer"  :title="'添加用户'"  @getlist="getlist"></Drawers> -->
    <!-- <Dialog :id="2" ref="dialogRef" :cet="true" :title="'输入渠道名称'" @getlist="getlist" /> -->
    <Drawers ref="wTable" title="报名渠道信息"></Drawers>
<Dialog :id="12" ref="dialogRef" :cet="true" :title="'新增渠道'" @getlist="getlist" />
  </div>
</template>

<script>
let that
// import rules from '../../utils/rules'
import mixins from '@/mixin/list'
export default {
  components: {
    // Drawers: () => import('@/components/Drawer'),
    Dialog: () => import('@/components/popup.vue')
  },
  mixins: [mixins],
  data() {
    return {
      btn: true,
      action: {
        action: 'activity'
      },
      pagesize: 10,
      search: {
        page: 1,
        pageSize: 10
      },
      s_form: {
        page: 1,
        pageSize: 10,
        sendUser: '',
        receiveUser: '',
        status: '',
        createDate: []
        // order: ''
      }
    }
  },
  computed: {

  },
  beforeCreate() {
    that = this
  },
  updated() {
    //   console.log(this.form);
  },

  created() {
    // this.getconfig()
    // this.getconfig('user')
    this.getlist()
    sessionStorage.setItem('action', 'cooperation')
  },
  mounted() {
    // console.log(rules.req('撒打算'))
    // console.log(this.confing_d)
  },
  methods: {
    async handleClick(row) {
      const { data: res } = await this.$http.get("/admin/Activity/checkChannelApplyLists?channelId=" + row.id);
      this.$refs.wTable.interfaces = 15;
      this.$refs.wTable.list = res.data
      this.$refs.wTable.drawer = true;
    },
    handleSizeChange(e) {
      this.pagesize = e
      console.log(e)
    },

    getlist(val) {
      // /admin/Activity/getChannelList
      var form = val || this.search
      this.$http
        .get('/admin/Activity/getChannelListNew', {
          params: {
            ...form,
            activityId: this.$route.query.id
          }
        })
        .then(({ data: res }) => {
          if (res.errorCode == 200) {
            this.list = res.data.list
            this.total = res.data.totalCount
            this.title = res.data.activity.title
          }
        })
    },

    async add() {
      // this.$refs.drawer.drawer=true
      // this.$refs.drawer.getlist()
      this.$refs.dialogRef.dialogVisible = true
      this.$refs.dialogRef.edit = false
      this.$refs.dialogRef.form = {
        name: '',
        isSendBonus: 0,
        limit: 0,
        using: 'activity',
        activityId: this.$route.query.id
      }
          this.$refs.dialogRef.dialogVisible = true
          this.$refs.dialogRef.channel = true
            this.$refs.dialogRef.init({ activityId: this.$route.query.id, activityTitle: this.title })
        
    },
    edit(row) {
      this.$refs.dialogRef.dialogVisible = true
      this.$refs.dialogRef.edit = true
      this.$refs.dialogRef.form = {
        ...row
      }
       this.$refs.dialogRef.dialogVisible = true
            this.$refs.dialogRef.init({ activityId: row.activityId, activityTitle: this.title }, { couponId: row.couponId, couponName: row.couponName })
    },

    open(id) {
      this.$confirm('此操作将永久删除该, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http
            .post('/admin/Activity/channelDel', { id: id })
            .then(res => {
              if (res.data.errorCode == 200) {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
                if (this.total % 10 == 1 && this.total != 1) {
                  this.search.page--
                }
                this.getlist()
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>

<style lang="less" scoped>
.out {
  // width: 500px;

  margin-bottom: 20px;

  .input {
    width: 37%;
    display: inline-block;
    margin-right: 30px;
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.skyblue {
  color: skyblue;
}

.green {
  color: green;
}

.yellow {
  color: pink;
}

.red {
  color: red;
}

.out .input {
  width: 18%;
}

.el-card {
  position: relative;
}

.out .right {
  float: right;
}

.box {
  display: inline-block;
  margin: 5px;
}
</style>
